import React from 'react'
import { Link } from 'react-router-dom'

const PatientFormList = ({forms = []}) => {
  return (
    <div>
          {/* Forms List Section */}
      <section className="container mx-auto py-16 px-6">
        <h2 className="text-4xl font-bold text-primary mb-12 text-center">
          Choose a Form to Get Started
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {forms.map((form) => (
            <Link
              key={form.id}
              to={form.link}
              className="group relative border border-gray-300 p-8 rounded-2xl hover:bg-primary hover:text-white hover:border-transparent transition-all duration-300 shadow-lg"
            >
              <div className="flex flex-col items-center justify-center h-full space-y-6 text-center">
                <span className="text-5xl">{form.icon}</span>
                <h3 className="text-2xl font-semibold">{form.title}</h3>
               
              </div>
              {/* Subtle Icon Animation */}
              <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 rounded-2xl transition-all duration-300"></div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  )
}

export default PatientFormList